module.exports = __webpack_public_path__ + "static/media/tire-flat.687f7036.svg";